export default __webpack_public_path__ + "static/media/canada-flag.ed12b373.png";